import React from "react";
import { theme } from "../Styles/theme";

const MaginfierEyeIcon = ({ style}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      style={style}
    >
      <path
        d="M23.561,21.439l-5.514-5.514c1.225-1.66,1.959-3.703,1.959-5.92C20.006,4.492,15.52,.006,10.006,.006S.006,4.492,.006,10.006s4.486,10,10,10c2.216,0,4.26-.734,5.92-1.959l5.514,5.514c.293,.293,.677,.439,1.061,.439s.768-.146,1.061-.439c.586-.586,.586-1.535,0-2.121Zm-13.555-4.434c-3.859,0-7-3.141-7-7S6.146,3.006,10.006,3.006s7,3.14,7,7-3.141,7-7,7Zm5.691-7.926c-.901-1.285-2.697-3.08-5.697-3.08-3.052,0-4.858,1.859-5.743,3.147-.354,.515-.354,1.191,0,1.706,.885,1.287,2.692,3.147,5.743,3.147,2.999,0,4.796-1.796,5.697-3.08,.393-.56,.393-1.279,0-1.84Zm-5.697,2.92c-1.105,0-2-.895-2-2s.895-2,2-2,2,.895,2,2-.895,2-2,2Z"
        fill={`${theme.main}`}
      />
    </svg>
  );
};

export default MaginfierEyeIcon;
